// extracted by mini-css-extract-plugin
export var absolute = "loader-module--absolute--lX5TH";
export var container = "loader-module--container--4viHi";
export var fixed = "loader-module--fixed--u-VEc";
export var icon = "loader-module--icon--eGxAD";
export var wand = "loader-module--wand--BMSvY";